(function () {
  var SLR_KK_IMAGE_SOURCES = {
    '1': 'https://cdn.shopify.com/s/files/1/0984/8402/7774/files/smartphone-anleitung-fuer-senioren-inhaltsverzeichnis.webp?v=1779496106',
    '2': 'https://cdn.shopify.com/s/files/1/0984/8402/7774/files/app-uebersicht-oeffnen-apps-installieren.webp?v=1779495984',
    '3': 'https://cdn.shopify.com/s/files/1/0984/8402/7774/files/whatsapp-oeffnen-anleitung-fuer-senioren.webp?v=1779496020',
    '4': 'https://cdn.shopify.com/s/files/1/0984/8402/7774/files/handy-schrift-vergroessern-abschluss.webp?v=1779496143'
  };

  function fixKKInsideImages(scope) {
    var root = scope || document;

    root.querySelectorAll('.kk-inside-stage').forEach(function (stage) {
      Object.keys(SLR_KK_IMAGE_SOURCES).forEach(function (index) {
        var expectedSource = SLR_KK_IMAGE_SOURCES[index];

        stage.querySelectorAll('.kk-page-' + index).forEach(function (image) {
          var isSnippetImage = image.getAttribute('data-slr-kk-image') === 'true';

          if (!isSnippetImage) {
            image.remove();
            return;
          }

          image.setAttribute('src', expectedSource);
          image.setAttribute('data-kk-src', expectedSource);
          image.setAttribute('data-slr-kk-fixed', 'true');

          if (image.dataset.slrKkErrorReady === 'true') return;
          image.dataset.slrKkErrorReady = 'true';

          image.addEventListener('error', function () {
            if (image.dataset.slrKkReloaded === 'true') return;
            image.dataset.slrKkReloaded = 'true';
            image.src = expectedSource + (expectedSource.indexOf('?') > -1 ? '&' : '?') + 'slr_retry=1';
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixKKInsideImages(document);
    });
  } else {
    fixKKInsideImages(document);
  }

  window.setTimeout(function () {
    fixKKInsideImages(document);
  }, 300);

  document.addEventListener('shopify:section:load', function (event) {
    fixKKInsideImages(event.target);
    window.setTimeout(function () {
      fixKKInsideImages(event.target);
    }, 300);
  });
})();
